/**
 * Rate Limiter
 * Client-side rate limit checking
 */

export class RateLimiter {
  /**
   * Check if submission is allowed based on rate limits
   * @param {Object} submissionLimits - Submission limits config
   * @param {Object} currentUser - Current user data
   * @returns {Object}
   */
  static checkRateLimit(submissionLimits, currentUser) {
    if (!submissionLimits || !submissionLimits.enabled) {
      return { allowed: true };
    }

    const isLoggedIn = currentUser && currentUser.id;

    // Check if login is required
    if (submissionLimits.require_login && !isLoggedIn) {
      return {
        allowed: false,
        error: submissionLimits.guest_limit_message || 'Please log in to submit this form.'
      };
    }

    // Rate limiting is handled server-side for logged-in users
    // This is just a client-side check for login requirement
    return { allowed: true };
  }
}

